import { api } from './apiClient';
import type { ApiResponse, Paginated, Query } from '../../types/api';

/**
 * Standard REST calls for one collection, e.g. crudService<Customer, CustomerInput>('/customers').
 * Module services spread this and add their own endpoints.
 */
export function crudService<T, TInput = Partial<T>>(base: string) {
  return {
    /** Paged list: { data, meta } */
    list: (query?: Query) => api.get<Paginated<T>>(base, query),
    get: (id: string) => api.get<ApiResponse<T>>(`${base}/${id}`).then((r) => r.data),
    create: (body: TInput) => api.post<ApiResponse<T>>(base, body).then((r) => r.data),
    update: (id: string, body: Partial<TInput>) => api.patch<ApiResponse<T>>(`${base}/${id}`, body).then((r) => r.data),
    remove: (id: string) => api.del(`${base}/${id}`),
  };
}
